// @ts-nocheck
import React, { ReactNode } from "react";
import Markdown from "react-markdown";
import { BlockMath, InlineMath } from "react-katex";
import gfm from "remark-gfm";
import math from "remark-math";
import { Code, Heading, Text } from "@chakra-ui/react";
// import "katex/dist/katex.min.css";

const defaultStyles: { [key: string]: any } = {
  h1: { m: "0.67em 0", fontSize: "2em" },
  h2: { m: "0.83em 0", fontSize: "1.5em" },
  h3: { /*m: "0.3em 0",*/ fontSize: "1.17em" },
  h4: { m: "1.33em 0", fontSize: "1.33em" },
  h5: { m: "1.67em 0", fontSize: "0.83em" },
  h6: { m: "2.33em 0", fontSize: "0.67em" },
};

const renderers = {
  blockquote({ children }: { children: ReactNode }) {
    return (
      <blockquote
        style={{
          margin: "1em 40px",
        }}
      >
        {children}
      </blockquote>
    );
  },

  code({ value }: { value: ReactNode }) {
    return <Code children={value} p="16px" />;
  },

  heading({ level, children }: { children: ReactNode; level: number }) {
    const tag = `h${level}`;
    const styles = defaultStyles[tag];
    return (
      <Heading as={tag} {...styles}>
        {children}
      </Heading>
    );
  },

  inlineCode({ value }: { value: ReactNode }) {
    return <Code children={value} p="2px 4px" />;
  },

  inlineMath({ value }: { value: ReactNode }) {
    return <InlineMath math={value} />;
  },

  link({ children }: { children: ReactNode }) {
    return <u>{children}</u>;
  },

  list({
    children,
    ordered,
  }: {
    children: React.ReactChild;
    ordered: boolean;
  }) {
    const styles = {
      paddingLeft: "40px",
      margin: "1em 0",
      listStyleType: ordered ? "decimal" : "disc",
    };
    if (ordered) {
      return <ol style={styles}>{children}</ol>;
    }
    return <ul style={styles}>{children}</ul>;
  },

  math({ value }: { value: string }) {
    return <BlockMath math={value} />;
  },

  paragraph({ children }: { children: ReactNode }) {
    return <Text mb={3} /* m="1em 0" */>{children}</Text>;
  },

  tableCell({
    children,
    isHeader,
  }: {
    children: ReactNode;
    isHeader: boolean;
  }) {
    const styles = {
      border: "1px solid",
      padding: "1em",
    };

    if (isHeader) {
      return <th style={styles}>{children}</th>;
    }
    return <td style={styles}>{children}</td>;
  },
};

type Props = {
  text: string;
};
const Component = ({ text }: Props) => (
  <Markdown children={text} plugins={[gfm, math]} renderers={renderers} />
);
export default Component;
